import StatisticCreateModalController from "./create-modal";
import editorModalTemplate from "../views/create-statistic.tpl.html";

export default class AlGuestlistStatisticController {

    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;

        this.api = this.injector.get('$http');
        this.uibModal = this.injector.get('$uibModal');
        this.navService = this.injector.get('NavService');
        this.acl = this.injector.get('Acl');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
        this.refresh = null;
        this.maximize = null;
        this.pieGraphs = []
        this.currentSelected = '';
        this.fieldLabel = '';
        this.guestlist = null
        this.graphColors = ['#9c62ff', '#04cac3', '#f5b858', '#bb94ff', '#87e5e2', '#9499da', '#e01249', '#ddd5ee']

        this.statistic = null;
        this.isLoading = false;
        this.data = [];
        this.scope.pieOptions = {borderWidth: 1};

        this.sortField = 'total';
        this.sortDirectionTotal = 'desc';
        this.sortDirectionLabel = 'asc';
    }

    $onInit() {
        this.maximizeMe = () => this.maximize(this.statistic);
        this.closeMaximize = () => this.maximize(null);
        this.selfRefresh();

        const fieldPath = this.statistic.config.params.groupBy[0].split('.');
        const fields = this.guestlist.enabled_fields;
        const table = fieldPath[0] === 'contacts' ? 'contact' : 'rsvp';
        this.fieldLabel = fields[table][fieldPath[1]].label;
    }

    selfRefresh() {
        this.isLoading = true;
        this.api.get("stats/statistics/" + this.statistic.id).then(({data}) => {

            this.data = data.result.values;
            this.totaCount = data.result.total;
            this.pieGraphs = []

            this.data = this.data.map((item, index) => {
                return {
                    ...item,
                    label: item.label,
                    color: this.generateColor(index, item, this.statistic)
                }
            });

            this.updateDataSort();
            this.currentSelected = this.data[0];
            this.isLoading = false;
        })
            .catch((e) => {
                this.isLoading = false;
                return e;
            });
    }

    onPieClick(id) {
        this.currentSelected = this.data.find((item) => {
            return item.id === id;
        });
    }

    polarToCartesian(centerX, centerY, radius, angleInDegrees) {
        const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

        return {
            x: centerX + (radius * Math.cos(angleInRadians)),
            y: centerY + (radius * Math.sin(angleInRadians))
        };
    }

    generateColor(seed, item, statistic) {

        const randomColor = () => {
            const colorCount = this.graphColors.length;

            if (seed < colorCount) {
                return this.graphColors[seed];
            }

            return this.graphColors[(seed + 1) % colorCount]
        }


        if (statistic.config.colors === undefined) {
            return randomColor();
        }
        const customColor = statistic.config.colors.find(({label}) => item.label === label);

        if (customColor === undefined || customColor.color === '') {
            return randomColor();
        }

        return customColor.color;
    }

    describeArc(x, y, radius, startAngle, endAngle) {

        const start = this.polarToCartesian(x, y, radius, endAngle);
        const end = this.polarToCartesian(x, y, radius, startAngle);

        const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

        return [
            "M", start.x, start.y,
            "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
        ].join(" ");
    }

    calcArc(percentage, currentPosition) {
        const circleValue = 360 * (percentage / 100);
        const barHeight = 200 * (percentage / 100);
        const endPosition = currentPosition + circleValue;
        return {d: this.describeArc(50, 50, 40, currentPosition, endPosition), endPosition, barHeight}
    }

    sortTotal(firstEl, secondEl, direction) {
        if (firstEl.value === secondEl.value) {
            return this.sortLabel(firstEl, secondEl, 'asc')
        }

        if (direction === 'asc') {
            return firstEl.value - secondEl.value
        }

        if (direction === 'desc') {
            return secondEl.value - firstEl.value
        }

        return 0;
    }

    sortLabel(firstEl, secondEl, direction) {
        const nameA = firstEl.label.toUpperCase();
        const nameB = secondEl.label.toUpperCase();

        if (nameA === nameB) {
            return this.sortTotal(firstEl, secondEl, 'desc');
        }

        if (direction === 'asc') {
            return nameA.localeCompare(nameB);
        }

        if (direction === 'desc') {
            return nameB.localeCompare(nameA);
        }

        return 0;
    }


    sort(field) {
        if (this.sortField === field) {
            if (field === 'total') {
                this.sortDirectionTotal = this.sortDirectionTotal === 'asc' ? 'desc' : 'asc';
            }

            if (field === 'label') {
                this.sortDirectionLabel = this.sortDirectionLabel === 'asc' ? 'desc' : 'asc';
            }
        } else {
            if (field === 'total') {
                this.sortDirectionTotal = 'desc';
            }

            if (field === 'label') {
                this.sortDirectionLabel = 'asc';
            }
        }

        this.sortField = field;

        this.updateDataSort()
    }

    updateDataSort() {
        this.data = this.data.sort((firstEl, secondEl) => {
            if (this.sortField === 'total') {
                return this.sortTotal(firstEl, secondEl, this.sortDirectionTotal);
            }

            if (this.sortField === 'label') {
                return this.sortLabel(firstEl, secondEl, this.sortDirectionLabel);
            }
        });

        let currentPosition = 0;
        this.pieGraphs = this.data.map((item) => {
            const {d, endPosition, barHeight} = this.calcArc(item.percentage, currentPosition);
            currentPosition = endPosition;

            return {
                id: item.id,
                color: item.color,
                d,
                percentage: item.percentage,
                barHeight
            };
        })
    }

    delete() {
        this.api.delete("stats/statistics/" + this.statistic.id)
            .then(({data}) => {
                this.refresh();
            })
            .catch((e) => e);
    }

    openEditStatisticModal() {
        this
            ._openEditorModal(StatisticCreateModalController, {
                refresh: this.refresh,
                statistic: this.statistic,
                guestlist: this.guestlist,
                data: this.data
            })
            .then(() => {
            });
    }

    _openEditorModal(controller, extendedInformation) {
        extendedInformation = extendedInformation || {};

        return this.uibModal.open({
            controller,
            controllerAs: 'vm',
            templateUrl: editorModalTemplate,
            resolve: {
                extendedInformation: () => extendedInformation
            }
        }).result;
    }
}

AlGuestlistStatisticController.$inject = [
    '$scope',
    '$injector',
    '$element',
];



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-dashboard/controllers/statistic.js